import React from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import Link from '@components/atoms/link/link';
import Environment from '@config/index';
import styles from '@components/molecules/products/product-details/components/product-installment/modal-payment-installment/modal-payment-installment.module.scss';

const Klarna = () => {
  const { t } = useTranslation();

  return (
    <div className={clsx(styles.modalPaymentContainer, styles['modalPaymentContainer--klarna'])}>
      <div className={clsx(styles.modalPayment__title, 'vc-modal__title')}>{t('MODAL_PAYMENT.KLARNA.TITLE')}</div>

      <p className={styles.modalPayment__intro}>{t('MODAL_PAYMENT.KLARNA.INTRO')}</p>

      <ul className={styles.modalPayment__list}>
        <li className={styles.modalPayment__item}>
          <img
            className={clsx(styles.modalPayment__item__icon, styles['modalPayment__item__icon--calendar'])}
            src={`${Environment.cdnFolder}/assets/svg/calendar.svg`}
            alt=""
          />

          <div className={styles.modalPayment__item__text}>
            <p className={styles.modalPayment__item__text__paragraph}>{t('MODAL_PAYMENT.KLARNA.DELIVERY_PARAGRAPH')}</p>
          </div>
        </li>

        <li className={styles.modalPayment__item}>
          <img
            className={clsx(styles.modalPayment__item__icon, styles['modalPayment__item__icon--banknote'])}
            src={`${Environment.cdnFolder}/assets/svg/banknote.svg`}
            alt=""
          />

          <div className={styles.modalPayment__item__text}>
            <p className={styles.modalPayment__item__text__paragraph}>{t('MODAL_PAYMENT.KLARNA.PAYMENT_PARAGRAPH')}</p>
          </div>
        </li>
      </ul>

      <p className={styles.modalPayment__tips}>
        <span>{t('MODAL_PAYMENT.KLARNA.TIPS.TEXT')}</span>

        <Link
          href="https://www.vestiairecollective.com/klarna/"
          target="_blank"
          className={styles.modalPayment__tips__link}
        >
          {t('MODAL_PAYMENT.SPLITIT.TIPS.LINK_TEXT')}
        </Link>
      </p>
    </div>
  );
};

export default Klarna;
